<template>
  <svg
    class="animate-spin text-yapgray-700 dark:text-primary-dark-100"
    :class="{
      'h-5 w-5': props.size === YapLoaderSizes.Small,
      'h-8 w-8': props.size === YapLoaderSizes.Medium,
      'h-10 w-10': props.size === YapLoaderSizes.Large
    }"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    data-testid="yap-loader"
  >
    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
    <path
      class="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
</template>

<script lang="ts">
export enum YapLoaderSizes {
  Small = 'small',
  Medium = 'medium',
  Large = 'large'
}
</script>
<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    size: YapLoaderSizes;
  }>(),
  { size: YapLoaderSizes.Small }
);
</script>
